import { apiSlice } from "./apiSlice";
import { OUTLET_URL } from "../constants";

const outletApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOutlet: builder.mutation({
      query: (data) => ({
        url: `${OUTLET_URL}/createOutlet`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getMyOutlets: builder.query({
      query: (data) => ({
        url: `${OUTLET_URL}/getMyOutlets?${data?.query ? data?.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    getOutletDetails: builder.query({
      query: (data) => ({
        url: `${OUTLET_URL}/getOutlet/${data?.id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    editOutletDetails: builder.mutation({
      query: (data) => ({
        url: `${OUTLET_URL}/editOutletDetails`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    uploadOutletPhoto: builder.mutation({
      query: (data) => ({
        url: `${OUTLET_URL}/uploadOutletPhoto`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateOutletMutation,
  useGetMyOutletsQuery,
  useGetOutletDetailsQuery,
  useEditOutletDetailsMutation,
  useUploadOutletPhotoMutation,
} = outletApiSlice;
